// Shared utility for video background blocks
// Iterates over video background containers matching a selector and yields
// the iframe + thumbnail pairs for player-specific initialization.
//
// Containers may hold more than one iframe (e.g. desktop + mobile-portrait
// variants in bunny-video-background). The callback fires once per iframe;
// if there are matching desktop/mobile thumbnails the closest one is paired,
// otherwise it falls back to the first thumbnail in the container.

const SCOPE = ".design-system";

const matchedThumbnail = (iframe, thumbnails) => {
  if (thumbnails.length <= 1) return thumbnails[0];
  const isMobile = iframe.classList.contains("video-background__iframe--mobile");
  const variant = isMobile
    ? "video-background__thumbnail--mobile"
    : "video-background__thumbnail--desktop";
  for (const t of thumbnails) {
    if (t.classList.contains(variant)) return t;
  }
  return thumbnails[0];
};

/**
 * Find all video background containers matching a data-attribute selector,
 * yielding { iframe, thumbnail } pairs once per iframe.
 *
 * @param {string} selector - Data-attribute selector (e.g. "[data-bunny-video]")
 * @param {(ctx: { iframe: HTMLIFrameElement, thumbnail: HTMLElement }) => void} callback
 */
export const eachVideoBackground = (selector, callback) => {
  const containers = document.querySelectorAll(`${SCOPE} ${selector}`);
  for (const container of containers) {
    const iframes = container.querySelectorAll("iframe");
    const thumbnails = container.querySelectorAll(".video-background__thumbnail");
    if (!iframes.length || !thumbnails.length) continue;
    for (const iframe of iframes) {
      const thumbnail = matchedThumbnail(iframe, thumbnails);
      if (!thumbnail) continue;
      callback({ iframe, thumbnail });
    }
  }
};
